import { aPIPaths, handleResponse, methods, requestBO } from "../../Config";

export const ApplicationsService = {
  getApplicationList,
  getManualRiskList,
  setManualRiskList,
  getSanctionsList,
  reviewSanction,
  allSanctionReviewed,
  getDocuments,
  getApplication,
  rejectApplication,
  rejectDueSanctionList,
  requestAdditionalDocuments,
  approveRisk,
  approveBeneficiaries,
  uploadDocuments,
  addRisk,
  setReviewKycStatus,
  setMissingDocuments,
  confirmUploadedAgreements,
  rejectUploadedAgreement,
  getClientRisksList,
  updateRiskHit,
  getUploadedDocumentsList,
  renewKyc,
  retryPrefill
};

function getApplicationList(data) {
  return requestBO(aPIPaths.getApplicationList, {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function getManualRiskList() {
  return requestBO(aPIPaths.getManualAmlRiskList, {
    method: methods.get
  }).then(handleResponse);
}

function setManualRiskList(data, id) {
  return requestBO(aPIPaths.setManualAmlRiskList.replace("{applicationId}", id), {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function updateRiskHit(data, id) {
  return requestBO(aPIPaths.updateRiskHit.replace("{applicationId}", id), {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function getSanctionsList(id) {
  return requestBO(aPIPaths.getSanctionsList.replace("{applicationId}", id)).then(handleResponse);
}

function reviewSanction(data, id) {
  return requestBO(aPIPaths.reviewSanction.replace("{applicationId}", id), {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function allSanctionReviewed(id) {
  return requestBO(aPIPaths.allSanctionReviewed.replace("{applicationId}", id), {
    method: methods.post
  }).then(handleResponse);
}

function getDocuments(id) {
  return requestBO(aPIPaths.getDocuments.replace("{applicationId}", id)).then(handleResponse);
}

function getUploadedDocumentsList(id) {
  return requestBO(aPIPaths.getUploadedDocumentsList.replace("{applicationId}", id)).then(handleResponse);
}

function getApplication(id) {
  return requestBO(aPIPaths.getApplication.replace("{applicationId}", id)).then(handleResponse);
}

function rejectApplication(id, data) {
  return requestBO(aPIPaths.rejectApplication.replace("{applicationId}", id), {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function rejectDueSanctionList(id, data) {
  return requestBO(aPIPaths.rejectDueSanctionList.replace("{applicationId}", id), {
    method: methods.post
  }).then(handleResponse);
}

function requestAdditionalDocuments(data, id) {
  return requestBO(aPIPaths.requestAdditionalDocuments.replace("{applicationId}", id), {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function approveRisk(id, data) {
  return requestBO(aPIPaths.approveRisk.replace("{applicationId}", id), {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function addRisk(id, data) {
  return requestBO(aPIPaths.addRisk.replace("{applicationId}", id), {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function approveBeneficiaries(id) {
  return requestBO(aPIPaths.approveBeneficiaries.replace("{applicationId}", id), {
    method: methods.post
  }).then(handleResponse);
}

function uploadDocuments(id, type, data) {
  return requestBO(
    aPIPaths.uploadDocuments.replace("{applicationId}", id).replace("{documentType}", type),
    {
      method: methods.post,
      data: data
    }
  ).then(handleResponse);
}

function renewKyc(id) {
  return requestBO(
    aPIPaths.renewKyc.replace("{applicationId}", id),
    {
      method: methods.post
    }
  ).then(handleResponse);
}

function retryPrefill(id) {
  return requestBO(
    aPIPaths.retryPrefill.replace("{applicationId}", id),
    {
      method: methods.post
    }
  ).then(handleResponse);
}

function setReviewKycStatus(id, data) {
  return requestBO(aPIPaths.setReviewKycStatus.replace("{applicationId}", id), {
    method: methods.post,
    data
  }).then(handleResponse);
}

function setMissingDocuments(id, data) {
  return requestBO(aPIPaths.setMissingDocuments.replace("{applicationId}", id), {
    method: methods.post,
    data
  }).then(handleResponse);
}

function confirmUploadedAgreements(id) {
  return requestBO(aPIPaths.confirmUploadedAgreements.replace("{applicationId}", id), {
    method: methods.get
  }).then(handleResponse);
}

function rejectUploadedAgreement(id, comment) {
  return requestBO(aPIPaths.rejectUploadedAgreement.replace("{applicationId}", id), {
    method: methods.post,
    data: JSON.stringify(comment)
  }).then(handleResponse);
}

function getClientRisksList(id) {
  return requestBO(aPIPaths.getClientRisksList.replace("{applicationId}", id), {
    method: methods.get
  }).then(handleResponse);
}
